import { sendCopyTask } from "@/models/tasks.model";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils";

type UseDuplicateTaskProps = {
  onTaskDuplicated: (newTaskID: number) => Promise<void>;
};

export default function useDuplicateTask({
  onTaskDuplicated,
}: UseDuplicateTaskProps) {
  async function duplicateTask(taskID: number) {
    try {
      const res = await sendCopyTask({ taskID });
      if (res.rStatus === "success") {
        genericSuccessToast("Task duplicated!");
        if (onTaskDuplicated) await onTaskDuplicated(res.taskID);
      } else {
        genericFailureToast("Error duplicating task");
      }
    } catch (error) {
      console.log("Error duplicating task:", error);
      genericFailureToast(
        "An unexpected error occurred while duplicating the task."
      );
    }
  }

  return { duplicateTask };
}
